import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import  {postData, getData } from '../ApiCalls/DataApis';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import IconButton from '@material-ui/core/IconButton';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PasswordInfoModal from '../components/PasswordInfoModal';


const styles = theme => ({
  paper: {
    position: 'relative',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]:{
      width: theme.spacing(43),
    }
  },
  button: {
    backgroundColor:'transparent',
    borderRadius:'24px',
    border:'1px solid #4f86ce',
    display:'inline-block',
    cursor:'pointer',
    color:'#4f87cc',
    fontFamily:'Trebuchet MS',
    fontSize:'12px',
    // font-weight:bold;
    padding:'3px 14px',
    textDecoration:'none',
    textShadow:'0px 0px 0px #9eb9ff',
    outline: 'none',
    '&:hover': {
      backgroundColor:'transparent',
    },
    '&:active': {
      position:'relative',
      top:'1px',
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialog: { borderRadius: 10 } ,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class CreateClientModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      success: false,
      deviceApiKeyName: '',
      deviceApiKeyDescription: '',
      passwordInfoModalOpen: false,
      generated_client_id:'',
      generated_password: '',
      clientName: '',
      device_disabled: this.props.device_disabled,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.submitButtonClick = this.submitButtonClick.bind(this);
  }



  timer = undefined;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      device_disabled: nextProps.device_disabled,
    }); 
  };

  handleOpen = () => {
    this.setState({ 
      open: true,
      loading: false,
      success: false,
      deviceApiKeyName: '',
      deviceApiKeyDescription: '',
      passwordInfoModalOpen: false,
      generated_client_id:'',
      generated_password: '',
      clientName:'',
    });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      loading: false,
      success: false,
      deviceApiKeyName: '',
      deviceApiKeyDescription: ''
    });
  };

  handleDeviceApiKeyNameChange = (event) => {
    this.setState({deviceApiKeyName: event.target.value});
  }

  handleDeviceApiKeyDescriptionChange = (event) => {
    this.setState({deviceApiKeyDescription: event.target.value});
  }

  submitButtonClick = () => {
    const { loading } = this.state;
    if (!loading) {
      this.setState(
        {
          success: false,
          loading: true,
          passwordInfoModalOpen: false,
        },
        () => {
        postData('https://api.iotflows.com/v1/devices/' + this.props.device_uuid + '/clients', 
        {'client_name': this.state.deviceApiKeyName,
          'client_description': this.state.deviceApiKeyDescription})
          .then(async response => {
            if(response.ok){
              const data = await response.json();
              this.props.showSuccessSnackbar("Device API Key has been successfully added!");
              this.props.refreshClientList();
              this.setState({
                loading: false,
                success: true,
                open:false,
                passwordInfoModalOpen: true,
                generated_client_id: data.data[0].client_id,
                generated_password: data.data[0].password,
                clientName: this.state.deviceApiKeyName,
              }, ()=> {this.handleClose()});
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  loading: false,
                  success: false,
                  open:false,
                  passwordInfoModalOpen: false,
                }, ()=> {this.handleClose()});
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong');
              }
            }
          })
        }
      )
    }
  };


  render() {
    const { classes } = this.props;
    const { open, 
            loading, 
            success, 
            passwordInfoModalOpen, 
            generated_client_id, 
            generated_password, 
            device_disabled, 
            deviceApiKeyName, 
            deviceApiKeyDescription,
            clientName} = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    

    return (
      <Grid
        container
        alignItems="flex-start"
        justify="flex-start"
        direction="column"
      >
        {/* <IconButton className={classes.button}  variant="contained"  onClick={this.handleOpen}>
          <Col>
            <Row>
              <AddCircleOutlineOutlinedIcon style={{fontSize: '24px'}} />  
            </Row>
            <Row>
              Add
            </Row> 
          </Col>
          
        </IconButton> */}
        <Button className={classes.button} variant="contained"  disabled={device_disabled} onClick={this.handleOpen}><AddCircleOutlineOutlinedIcon />&nbsp;Create Device API Key </Button>
        {passwordInfoModalOpen ?
          <PasswordInfoModal open={passwordInfoModalOpen} generated_client_id={generated_client_id} generated_password={generated_password} selected_device={this.props.selected_device} clientName={clientName} /> 
          :null}
          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                <DialogTitle style={{paddingBottom: '0px'}} id="alert-dialog-slide-title">{"Create Device API Key "}</DialogTitle>
                <DialogContent dividers style={{paddingBottom: '20px', paddingTop: '0px'}}>
                <TextField
                  autoFocus
                  margin="normal"
                  id="deviceApiKeyName"
                  label="Device API Key Name"
                  type="text"
                  value={deviceApiKeyName} 
                  onChange={this.handleDeviceApiKeyNameChange}
                  fullWidth
                />

                <TextField
                  autoFocus
                  margin="normal"
                  id="deviceApiKeyDescription"
                  label="Device API Key Description"
                  type="text"
                  value={deviceApiKeyDescription} 
                  onChange={this.handleDeviceApiKeyDescriptionChange}
                  fullWidth
                />

                {/* <TextField
                autoFocus
                margin="normal"
                id="clientId"
                label="Client ID"
                type="text"
                fullWidth
                disabled
                /> */}

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button onClick={this.handleClose} >
                    Close
                  </Button>
                  <Button  color="primary" type='submit' className={buttonClassname} disabled={loading} onClick={this.submitButtonClick}>
                    Submit { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>
        
      </Grid>
    );
  }
}

CreateClientModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),

})
const mapStateToProps = state => state

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(CreateClientModal)); 
